import { MutationTree } from "vuex";
import { CameraResolution, CameraResolutionMutations, CameraResolutionState } from "./interface";
import { CameraResolutionMutationsTypes } from "./types";

export const mutations: MutationTree<CameraResolutionState> & CameraResolutionMutations = {
  [CameraResolutionMutationsTypes.SET_CAMERA_RESOLUTION](
    state: CameraResolutionState,
    payload: Array<CameraResolution>
  ): void {
    state.CameraResolutionById = {};
    state.CameraResolutionAllId = [];

    payload.forEach((role) => {
      state.CameraResolutionById[role._id] = role;
      state.CameraResolutionAllId.push(role._id);
    });
  }
};
